const AppTypeEnum = {
  QR_SCAN_APP        : 'qr',
  MOBILE_APP         : 'ma',
  SELF_ORDERING_KIOSK: 'so',
  SELF_CHECKOUT_POINT: 'sc'
}

export default AppTypeEnum
